export const styles = {
  icon: {
    transition: 'left 0.5s, top 0.5s',
    cursor: 'pointer',
    width: 30,
    height: 30,
    position: 'absolute',
    top: '1rem',
    right: '1rem',
  },
};
